const OPTION_INTERACTIVE_SELECTOR =
  'button, a, input:not([type="checkbox"]), select, textarea, [role="button"], .MuiIconButton-root';

const OPTION_CHECKBOX_SELECTOR = 'input[type="checkbox"], .MuiCheckbox-root';

const isClickOnInteractiveElement = (target: EventTarget | null): boolean => {
  const el = target as HTMLElement | null;
  if (!el?.closest) return false;
  if (el.closest(OPTION_CHECKBOX_SELECTOR)) return false;
  return !!el.closest(OPTION_INTERACTIVE_SELECTOR);
};

// eslint-disable-next-line import/no-unused-modules -- used by SelectWithoutAnimation.tsx and ClientSelect.tsx
export default isClickOnInteractiveElement;
